import gql from 'graphql-tag';

const CurrentTicket = gql`
  query CurrentTicket($id: ID!) {
    ticket(id: $id) {
      id
      anonymizedAt
      bankInformation
      city
      country
      createdAt
      dateOfBirth
      employer
      gender
      id
      nationality
      number
      passengerEmail
      passengerFirstName
      passengerLanguage
      passengerLastName
      passengerPhone
      pnr
      postCode
      profession
      source
      street
      token
      updatedAt
      promoCode {
        id
        code
        percentage
      }
      unclaimableAt
      widgetCommentFromPax
      bankName
      unclaimableBy {
        id
        email
        name
        surname
      }
      affiliate {
        id
        name
      }
      claimsConnection {
        edges {
          cursor
          node {
            id
            codeClaim
          }
        }
      }
      flightsPassengerTicketsConnection {
        edges {
          cursor
          node {
            id
            status
            passengerTicket {
              id
            }
            flight {
              id
              flightNumber
              delayedFlightId
              delayedFlight {
                id
                localActualDepartureDate
                localActualArrivalDate
                delayAtArrival
                cancelled
                diverted
                recovered
                airportOrigin {
                  name
                  iata
                }
                airportDestination {
                  name
                  iata
                }
              }
              airportOrigin {
                name
                iata
              }
              airportDestination {
                name
                iata
              }
              airline {
                iata
                name
              }
              blackDay {
                id
              }
              crisisDateInterval {
                id
              }
              number
              localArrivalDate
              localDepartureDate
            }
          }
        }
      }
    }
  }
`;

export { CurrentTicket };



// WEBPACK FOOTER //
// ./src/queries/CurrentTicket.js